module.exports = __webpack_public_path__ + "img/P150T_weapon_83.92346550.png";